import { render, staticRenderFns } from "./TablePagination.vue?vue&type=template&id=5a471f34&"
import script from "./TablePagination.vue?vue&type=script&lang=ts&"
export * from "./TablePagination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports